import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconForkSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconForkSimple"><Path d="M18 2C20.2091 2 22 3.79086 22 6C22 7.86384 20.7252 9.42998 19 9.87402V13H13V14.126C14.7252 14.57 16 16.1362 16 18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18C8 16.1362 9.27477 14.57 11 14.126V13H5V9.87402C3.27477 9.42998 2 7.86384 2 6C2 3.79086 3.79086 2 6 2C8.20914 2 10 3.79086 10 6C10 7.86384 8.72523 9.42998 7 9.87402V11H17V9.87402C15.2748 9.42998 14 7.86384 14 6C14 3.79086 15.7909 2 18 2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconForkSimple;
